import React from 'react';
import { Nav } from 'react-bootstrap';
import { FaList, FaBloggerB, FaThumbsUp, FaFileAlt, FaChartBar } from 'react-icons/fa';

function SideMenu() {
  return (
    <Nav defaultActiveKey="/JobListing" className="custom-vertical-nav" style={{ backgroundColor: '#172446',height:'691px' }}>

      <Nav.Link href="/JobListing" style={{ color: 'white', marginTop: '30px', '@media (max-width: 768px)': { marginTop: '10px' } }}>
        <FaList style={{ marginRight: '5px' }} />
        Job Listing
      </Nav.Link>

      <Nav.Link href="/BlogTable" style={{ color: 'white', marginTop: '20px', '@media (max-width: 768px)': { marginTop: '10px' } }}>
        <FaBloggerB style={{ marginRight: '5px' }} />
        Blogs
      </Nav.Link>

      <Nav.Link href="/SuccessStory" style={{ color: 'white', marginTop: '20px', '@media (max-width: 768px)': { marginTop: '10px' } }}>
        <FaThumbsUp style={{ marginRight: '5px' }} />
        Success Stories
      </Nav.Link>

      <Nav.Link href="/ResumeUpdate" style={{ color: 'white', marginTop: '30px', '@media (max-width: 768px)': { marginTop: '10px' } }}>
        <FaFileAlt style={{ marginRight: '5px' }} />
        Resume Update
      </Nav.Link>

      <Nav.Link href="/Reports" style={{ color: 'white', marginTop: '30px', '@media (max-width: 768px)': { marginTop: '10px' } }}>
        <FaChartBar style={{ marginRight: '5px' }} />
        Employer
      </Nav.Link>

    </Nav>
  );
}

export default SideMenu;
